import React from "react";
import { initI18nFromSSR } from "./i18n/initFromSSR";

//init dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ProductDetail from "./features/productdetail/ProductDetail";
import {
  getNumberAttribute,
  getJsonAttribute,
} from "../frontend/bootstrap/runtime";
import {
  IslandRegistry,
  mountIsland,
} from "../frontend/bootstrap/islandRegistry";

dayjs.extend(utc);
dayjs.extend(timezone);

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const registry = new IslandRegistry();

  registry.register("productDetail", () => {
    mountIsland("product-detail-app", (root) => {
      const productProps = getJsonAttribute(root, "data-product-props", null);
      const productSettings = getJsonAttribute(
        root,
        "data-product-settings",
        null
      );

      return (
        <ProductDetail
          productProps={productProps}
          productSettings={productSettings}
          selectedPricePolicyId={getNumberAttribute(
            root,
            "data-active-price-policy-id",
            0
          )}
          websitePricePolicyId={getNumberAttribute(
            root,
            "data-website-price-policy-id",
            0
          )}
        />
      );
    });
  });

  registry.mountAll();
});

